export const DEFAULT_DAYS_BEFORE_DUE_SOON = 90;
export const DEFAULT_DAYS_BEFORE_OVERDUE = 180;
